import React, { useContext } from "react";
import { RicosViewerContext } from "./../../../../../ricos-context";
import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import { getFullLinkUrl } from "./../../../../../_shared/link/get-full-link-url";
import {
  addAnchorTagToUrl,
  anchorScroll,
  convertRelObjectToString
} from "./../../../../../wix-rich-content-common";
import classes from "./link-viewer-wrapper.rtlignore-scss";
const LinkViewerWrapper = ({
  children,
  nodeType,
  link
}) => {
  const { anchorTarget, baseUrl, customAnchorScroll } = useContext(RicosViewerContext);
  if (!(link && nodeType !== Node_Type.BUTTON)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      className: link ? classes.anchor : void 0,
      href: link ? getFullLinkUrl(link, baseUrl) : void 0,
      target: link.target ? `_${link.target.toLowerCase()}` : anchorTarget,
      rel: link.rel && convertRelObjectToString(link.rel),
      onClick: link?.anchor ? (e) => {
        if (customAnchorScroll) {
          return customAnchorScroll(e, link?.anchor);
        }
        const anchorRefId = `viewer-${link?.anchor}`;
        const element = document.getElementById(anchorRefId);
        if (!element) {
          return;
        }
        addAnchorTagToUrl(anchorRefId);
        anchorScroll(element);
      } : void 0
    },
    children
  );
};
export {
  LinkViewerWrapper
};
//# sourceMappingURL=LinkViewerWrapper.js.map
